import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Avdhendra Singh </span>
            from <span className="purple"> Gwalior, India.</span>
            I am a Bachelor of Computer Application student from ITM University,Gwalior
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movies
            </li>
           
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Make thing Out of Curiosity !"{" "}
          </p>
          <footer className="blockquote-footer">Avdhendra Singh</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
